module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/safe-mobile-phone.0147c42e.gif";